'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var CID = require('cids');

var multiaddr = require('multiaddr');

var ndjson = require('iterable-ndjson');

var configure = require('../lib/configure');

var toIterable = require('stream-to-it/source');

module.exports = configure(function (_ref) {
  var ky = _ref.ky;
  return /*#__PURE__*/function () {
    var _findProvs = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cid, options) {
      var searchParams, res, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, message, _iterator2, _step2, _step2$value, ID, Addrs;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              searchParams = new URLSearchParams(options.searchParams);
              searchParams.set('arg', "".concat(new CID(cid)));
              if (options.numProviders) searchParams.set('num-providers', options.numProviders);
              if (options.verbose != null) searchParams.set('verbose', options.verbose);
              _context.next = 7;
              return _awaitAsyncGenerator(ky.post('dht/findprovs', {
                timeout: options.timeout,
                signal: options.signal,
                headers: options.headers,
                searchParams: searchParams
              }));

            case 7:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 10;
              _iterator = _asyncIterator(ndjson(toIterable(res.body)));

            case 12:
              _context.next = 14;
              return _awaitAsyncGenerator(_iterator.next());

            case 14:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 18;
              return _awaitAsyncGenerator(_step.value);

            case 18:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 44;
                break;
              }

              message = _value;

              if (!(message.Type === 3)) {
                _context.next = 23;
                break;
              }

              throw new Error(message.Extra);

            case 23:
              if (!(message.Type === 4 && message.Responses)) {
                _context.next = 41;
                break;
              }

              _iterator2 = _createForOfIteratorHelper(message.Responses);
              _context.prev = 25;

              _iterator2.s();

            case 27:
              if ((_step2 = _iterator2.n()).done) {
                _context.next = 33;
                break;
              }

              _step2$value = _step2.value, ID = _step2$value.ID, Addrs = _step2$value.Addrs;
              _context.next = 31;
              return {
                id: ID,
                addrs: (Addrs || []).map(function (a) {
                  return multiaddr(a);
                })
              };

            case 31:
              _context.next = 27;
              break;

            case 33:
              _context.next = 38;
              break;

            case 35:
              _context.prev = 35;
              _context.t0 = _context["catch"](25);

              _iterator2.e(_context.t0);

            case 38:
              _context.prev = 38;

              _iterator2.f();

              return _context.finish(38);

            case 41:
              _iteratorNormalCompletion = true;
              _context.next = 12;
              break;

            case 44:
              _context.next = 50;
              break;

            case 46:
              _context.prev = 46;
              _context.t1 = _context["catch"](10);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 50:
              _context.prev = 50;
              _context.prev = 51;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 55;
                break;
              }

              _context.next = 55;
              return _awaitAsyncGenerator(_iterator.return());

            case 55:
              _context.prev = 55;

              if (!_didIteratorError) {
                _context.next = 58;
                break;
              }

              throw _iteratorError;

            case 58:
              return _context.finish(55);

            case 59:
              return _context.finish(50);

            case 60:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 46, 50, 60], [25, 35, 38, 41], [51,, 55, 59]]);
    }));

    function findProvs(_x, _x2) {
      return _findProvs.apply(this, arguments);
    }

    return findProvs;
  }();
});